import React, { Fragment } from "react";
import { useIntl } from "react-intl";

import CountrySection from "@components/countriesPage/CountrySection/countrySection";
import CitiesSection from "@components/countriesPage/CitiesSection/citiesSection";
import FooterSection from "@components/countriesPage/FooterSection/footerSection";
import CountryWrapper from "@components/countriesPage/CountryWapper/countryWrapper";
import SEO from "@components/seo";
import Controls from "@components/Controls/controls";
import UniplacesFullContainer from "@components/UniplacesFullContainer/uniplacesFullContainer";
import HeroSection from "@components/HeroSection/heroSection";
import countries from '@constants/countries';

const heroImage = {
  url: `${process.env.CDN_URL}/images/accommodation-hero-image.png`,
  alt: 'Accommodation Hero Image'
};

const CountriesTemplate = ({ pageContext: { locale } }) => {
  const intl = useIntl();

  const list = countries.map(countrySectionData => {
      const {
        name,
        capitalCity,
        currencySymbol,
        currencyCode,
        callingCode,
        hasDescription,
        hasFooter,
        cities,
        slug
      } = countrySectionData;

      const countryFlag = {
        url: `${process.env.CDN_URL}/images/flag/${slug}.png`,
        alt: `${intl.formatMessage({ id: name })} flag`,
      };

      const countryImage = {
        url: `${process.env.CDN_URL}/images/countries/${slug}.jpg`,
        alt: `${intl.formatMessage({ id: name })} image`,
      };

      return (
        <CountryWrapper key={slug} countryName={intl.formatMessage({ id: name })}>
          <React.Fragment>
            <CountrySection
              name={name}
              capitalCity={intl.formatMessage({ id: capitalCity })}
              currencySymbol={currencySymbol}
              currencyCode={currencyCode}
              callingCode={callingCode}
              countryDescription={hasDescription}
              countryImage={countryImage}
              countryFlag={countryFlag}
            />
            <CitiesSection data={cities} locale={locale} />
            <FooterSection
              countryFooter={hasFooter}
              countrySlug={slug}
              countryName={name}
              locale={locale}
            />
          </React.Fragment>
        </CountryWrapper>
      );
    });

  return (
    <Fragment>
      <SEO
        titleKey={'Uniplaces Accommodation Page'}
        descriptionKey={'Apartments for rent: Rooms and Student Accommodation'}
        imageUrl={heroImage.url}
        lang={locale}
      />
      <HeroSection
        heroHeading={'The world we are in.'}
        heroSubheading={'Discover it. Book it.'}
        heroImage={heroImage}
      />
      <UniplacesFullContainer>
        <React.Fragment>
          {list}
          <Controls />
        </React.Fragment>
      </UniplacesFullContainer>
    </Fragment>
  );
};

export default CountriesTemplate;
